import Instafeed from 'instafeed.js';
import jQueryBridget from 'jquery-bridget'
import Flickity from 'flickity'

export default {
  init() {
    // JavaScript to be fired on all pages
    $('.btn-menu').on('click', function() {
      var $nav = $('.nav-overlay');

      $nav.addClass('nav-overlay--active');
      $('body').addClass('modal-open');
    });
    $('.close-btn').on('click', function() {
      var $nav = $('.nav-overlay');
      $('body').removeClass('modal-open');
      $nav.removeClass('nav-overlay--active');
    });
    $('.menu-item').on('click', function() {
      $('body').removeClass('modal-open');
    });

    // function htmlEntities(str) {
    //   return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    // }

    function populateFeed(images) {
      var $feedContainer = $('#instagram');
      $.each(images, function (key, data) {
        // var caption = htmlEntities(data.caption.text);
        var link = data.link;
        var image = data.images.standard_resolution.url;

        var content = '<div class="instagram-image col-6 col-md-4 col-lg-3"><a href="' + link + '" target="_blank" rel="noopener" title="' +  '" style="background-image: url(' + image + ');"></a></div>';

        $feedContainer.append(content);
      });
    }

    if (window.instagram !== undefined && window.instagram.apiKey !== undefined && window.instagram.apiKey !== null) {
      var instafeedConfig = new Instafeed({
        get: 'user',
        userId: 'self',
        sortBy: 'most-recent',
        limit: '4',
        resolution: 'standard_resolution',
        target: 'instagram',
        accessToken: window.instagram.apiKey,
        mock: true,
        success: function (response) {
          populateFeed(response.data);
        },
      });

      instafeedConfig.run();
    }
    // Flickity carousel setup
    Flickity.setJQuery( $ );
    jQueryBridget( 'flickity', Flickity, $ );

    $('.member-gallery').flickity({
      cellAlign: 'center',
      wrapAround: true,
      autoPlay: true,
      contain: true,
      pageDots: false,
      imagesLoaded: true,
      adaptiveHeight: true,
    });

    var $gallery = $('.gallery').flickity({
      cellAlign: 'center',
      wrapAround: true,
      autoPlay: 8000,
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      friction: 0.05,
      selectedAttraction: 0.001,
      groupCells: 2,
      imagesLoaded: true,
      adaptiveHeight: true,
    });

    var $galleryTotal = $('.gallery-total');
    var $galleryProg = $('.gallery-prog');
    var flkty = $gallery.data('flickity');
    function updateStatus() {
      var cellNumber = flkty.selectedIndex + 1;
      $galleryProg.text( cellNumber );
      $galleryTotal.text( flkty.slides.length );
    }
    updateStatus();
    $gallery.on( 'change.flickity', updateStatus );


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js